import Command from '@ckeditor/ckeditor5-core/src/command';
import { enableDisableKeywordOption } from "../../src/utils";
export default class InsertMediaCommand extends Command {

  execute() {
    this.editor.fire('insertmedia');
    this.isEnabled = false;
    this.refresh();
  }

  refresh() {
    this.listenTo(this.editor.editing.view.document, 'click', () => {
       this.isEnabled = getEnable(this.editor, false);
    });   

    // Listens CTRL + A or Select ALL is performed
    const selectAll = this.editor.commands.get( 'selectAll' );
    selectAll.on( 'execute', () => {
      this.isEnabled = getEnable(this.editor, true);
    } );
  }
}

function getEnable(editor, isSelectAll){
  return (isSelectAll ? editor.model.document.selection.getSelectedElement() : true)
      && !enableDisableKeywordOption(editor)
}